module.exports = __webpack_public_path__ + "static/media/fingerprint.77b07e67.svg";